<router-outlet></router-outlet>

<!-- <div id="feedbackPopup" *ngIf="feedbackPopupService.showFeedBackPopup$ | async">
  <div class="close-icon" (click)="feedbackPopupService.closeFeedbackPopup()">
    <app-icon name="close"></app-icon>
  </div>

  <iframe [src]="feedbackPopupService.feedbackUrl | SANITIZE: 'resourceUrl'"
    frameborder= "0" marginwidth= "0" marginheight= "0"
    style= "border: none; max-width:100%; max-height:100vh"
    allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen>
  </iframe>
</div> -->